export default "__VITE_ASSET__C8G0eOU1__"